var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlossaryDelete = function SvgGlossaryDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#glossary_delete_svg__a)",
    d: "M14.138 21.74h81.225v87.027H25.74c-6.408 0-11.603-5.195-11.603-11.603V21.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#glossary_delete_svg__b)",
    d: "M14.138 21.741c0-6.408 5.195-11.603 11.603-11.603h69.622v23.207H25.74c-6.408 0-11.603-5.195-11.603-11.604Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glossary_delete_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.216 60.216V31.207h17.406v29.009l-8.703-8.703-8.703 8.703Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#glossary_delete_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#glossary_delete_svg__e)",
    d: "M73.5 89c0-9.113 7.387-16.5 16.5-16.5s16.5 7.387 16.5 16.5-7.387 16.5-16.5 16.5S73.5 98.113 73.5 89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.204 82.204a1.833 1.833 0 0 1 2.593 0l11 11a1.833 1.833 0 0 1-2.593 2.593l-11-11a1.833 1.833 0 0 1 0-2.593Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96.796 82.204a1.833 1.833 0 0 0-2.593 0l-11 11a1.833 1.833 0 0 0 2.593 2.593l11-11a1.833 1.833 0 0 0 0-2.593Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossary_delete_svg__a",
    x1: 54.75,
    x2: 54.75,
    y1: 21.741,
    y2: 108.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82BBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5689C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossary_delete_svg__b",
    x1: 16.5,
    x2: 95.25,
    y1: 21.5,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5183BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6199D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossary_delete_svg__e",
    x1: 90,
    x2: 90,
    y1: 72.5,
    y2: 105.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F65050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E24848"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glossary_delete_svg__c",
    width: 23.405,
    height: 35.009,
    x: 61.216,
    y: 28.957,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176 0 0 0 0 0.541176 0 0 0 0 0.764706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_869_38246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_869_38246",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glossary_delete_svg__d",
    width: 60,
    height: 60,
    x: 60,
    y: 61,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_869_38246"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_869_38246",
    result: "shape"
  })))));
};
export default SvgGlossaryDelete;